/// <reference path="../../_references.ts" />
module onvio.setup.list {
    'use strict';

    class EngagementTemplateServiceProxy {
        // TODO - KMS - do we want bm-indirect-tax to pull in typings?
        // Type would be: BmIndirectTax.ITaxGroupService
        private taxGroupService: any;

        static $inject = [
            '$injector',
            '$q',
            'fef.PromiseUtils',
            'fef.Utils',
            'csEngagementTemplateV2',
            'csEngagementTemplateViewV1'
        ];

        constructor(
            private $injector: ng.auto.IInjectorService,
            private $q: ng.IQService,
            private promiseUtils: fef.IPromiseUtilsService,
            private utils: fef.IUtilsService,
            private engagementTemplateV2: cs.IEngagementTemplateV2Service,
            private engagementTemplateViewV1: cs.IEngagementTemplateViewV1Service) {
            // We have made 'taxGroupService' an optional dependency,
            // which means the injector needs to have the 'bm.indirect.tax' module
            // loaded ahead of time in order for it to be found here.
            try {
                this.taxGroupService = $injector.get('taxGroupService');
            } catch (e) {
                // taxGroupService was not loaded
                this.taxGroupService = undefined;
            }
        }

        getList(params: cs.IQueryFilter): ng.IPromise<cs.IPagedItemsDto<cs.IEngagementTemplateV2Dto>> {
            return this.engagementTemplateV2.postSearch(bmp.PostSearchUtils.convertGetListParamsToSearchParams(params));
        }

        getViewList(params: cs.IQueryFilter): ng.IPromise<cs.IPagedItemsDto<cs.IEngagementTemplateViewV1Dto>> {
            return this.engagementTemplateViewV1.postSearch(bmp.PostSearchUtils.convertGetListParamsToSearchParams(params));
        }

        get(params: any): ng.IPromise<cs.IEngagementTemplateV2Dto> {
            return this.engagementTemplateV2.get(params).then((data: any) => {
                if (this.taxGroupService && data.taxGroupId && data.taxGroupId !== '') {
                    return this.taxGroupService.get(data.taxGroupId).then((taxGroup: cs.INamedReferenceDto) => {
                        data.$taxGroup = taxGroup;
                        return data;
                    }).catch((response: any) => {
                        return data;
                    });
                } else {
                    return data;
                }
            });
        }

        getDefault(params: any): ng.IPromise<cs.IEngagementTemplateV2Dto> {
            return this.engagementTemplateV2.getDefault(params);
        }

        post(params: {
            data: cs.IEngagementTemplateV2Dto;
        }): ng.IPromise<cs.IStringDto> {
            params.data.taxGroupId = params.data.$taxGroup ? params.data.$taxGroup.id : undefined;
            return this.engagementTemplateV2.post(params);
        }

        put(params: {
            engagementTemplateId: string;
            data: any;
        }): ng.IPromise<cs.IStringDto> {
            // For PUT, done conditionally to prevent data loss.
            if (this.taxGroupService) {
                params.data.taxGroupId = params.data.$taxGroup ? params.data.$taxGroup.id : undefined;
            }
            return this.engagementTemplateV2.put(params);
        }

        delete(params: {
            engagementTemplateId: string;
        }): ng.IPromise<cs.IEngagementTemplateV2Dto> {
            return this.engagementTemplateV2.delete(params, true);
        }

        postSearch(params: cs.IPostSearchParams) {
            return this.engagementTemplateViewV1.postSearch(params);
        }
        postCount(params: cs.IPostSearchParams) {
            return this.engagementTemplateViewV1.postCount(params);
        }

    }

    angular.module('onvio.setup.list.EngagementTemplateServiceProxy',
        [
            'fef',
            'csEngagementTemplateV2',
            'csEngagementTemplateViewV1'
        ])
        .service('onvio.setup.list.EngagementTemplateServiceProxy', EngagementTemplateServiceProxy);
}
